import type { AxiosRequestConfig } from 'axios';

import { buildObjQuery } from '@/utils/util';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const customerService = {
  async fetchContactSentimentDist(
    params: FetchCustomerSentimentDistParams,
  ): Promise<FetchCustomerSentimentDistRes> {
    const wa = getCurrWorkspaceAlias();
    const query = buildObjQuery(params);
    const res = await defaultAxios.get(
      `/workspaces/${wa}/customers/recent_sentiment_dist${query}`,
    );
    return res.data;
  },
  async fetchContactSentimentList(
    params: FetchCustomerSentimentListParams,
    config: AxiosRequestConfig = {},
  ): Promise<CustomerSentimentContactItem[]> {
    const wa = getCurrWorkspaceAlias();
    const query = buildObjQuery(params);
    const res = await defaultAxios.get(
      `/workspaces/${wa}/customers/recent_sentiment_list${query}`,
      config,
    );
    return res.data.contacts;
  },
  async fetchAccountSentimentDist(
    params: FetchCustomerSentimentDistParams,
  ): Promise<FetchCustomerSentimentDistRes> {
    const wa = getCurrWorkspaceAlias();
    const query = buildObjQuery(params);
    const res = await defaultAxios.get(
      `/workspaces/${wa}/companies/recent_sentiment_dist${query}`,
    );
    return res.data;
  },
  async fetchAccountSentimentList(
    params: FetchCustomerSentimentListParams,
    config: AxiosRequestConfig = {},
  ): Promise<CustomerSentimentAccountItem[]> {
    const wa = getCurrWorkspaceAlias();
    const query = buildObjQuery(params);
    const res = await defaultAxios.get(
      `/workspaces/${wa}/companies/recent_sentiment_list${query}`,
      config,
    );
    return res.data.accounts;
  },
};

export default customerService;
